//LOGO
export const logo = '/assets/images/logoOne.svg'
export const secLogo = '/assets/images/logoTwo.svg'
export const png_logo = '/assets/images/logo.png'
export const siteName = 'Keystone'

class langObj {
    constructor(show, value) {
        this.show = show
        this.value = value
    }
    getLangObj() {
        return this
    }
}
export const languageArr = [
    new langObj('English', 'English'),
    new langObj('Mandarin', 'Mandarin'),
    new langObj('French', 'French'),
    new langObj('Spanish', 'Spanish'),
    new langObj('Portugese', 'Portugese'),
    new langObj('BrazilPortugese', 'BrazilPortugese'),
    new langObj('German', 'German'),
]
